import React, { useEffect } from 'react';

import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import { InputSelectWithOutIcon } from 'handimap-react-lib/components/InputSelectWithOutIcon';
import { useLabelValue } from 'handimap-react-lib/utils/useLabelValue';
import { ConditionTypo } from 'handimap-react-lib/components/Typography/ConditionTypography';
import { setProfil } from 'handimap-react-lib/store/actions/profilActions';
import { ConditionProfil } from 'handimap-react-lib/containers/ConditionProfil';
import { typeProfil } from 'handimap-react-lib/enum/typeProfil';
import { TypeSelectItem } from './TypeSelectItem';

export const Options = ({
  isMobile, 
  profileFromUrl, 
  conditionFromUrl, 
  showCondition
}) => {
  const { t } = useTranslation();
  const { setLabelProfile } = useLabelValue();
  const dispatch = useDispatch();


  const profilRedux = useSelector(state => state.profils.profil);
  const conditionRedux = useSelector(state => state.profils.condition);

  const handleProfile = profile => {
    dispatch(setProfil(profile));
  };

  const renderValueProfile = profile => {
    return (
      <ConditionTypo>
        {setLabelProfile(profile)}
      </ConditionTypo>
    );
  };
  
  useEffect(() => {
    if (profileFromUrl !== null && profileFromUrl !== undefined && profileFromUrl !== '') {
      handleProfile(profileFromUrl);
    }
  }, []);

  return (
    <Stack direction='column' spacing={2}>
      <InputSelectWithOutIcon
        isMobile={isMobile}
        label={t('form.profile-label')} 
        id='profil'
        role='presentation'
        value={profilRedux} 
        renderValue={() => renderValueProfile(profilRedux)}
        setValue={event => handleProfile(event.target.value)}
      >
        {Object.keys(typeProfil).map((type) => {
          return (
            <TypeSelectItem 
              value={typeProfil[type]}
              label={setLabelProfile(typeProfil[type])} 
              key={type}>
              {typeProfil[type]}
            </TypeSelectItem>
          );
        })}
      </InputSelectWithOutIcon>
      <ConditionProfil  
        isMobile={isMobile} 
        profil={profilRedux} 
        conditionValue={conditionRedux}
        conditionFromUrl={conditionFromUrl}
        showInput={showCondition}/>
    </Stack>
  );
};